import {useAsyncState} from 'common/hooks/useAsyncState';
import ApiService from 'api/ApiService';
import React from 'react';
import {useHandleApiError} from './useHandleApiError';

export function useGetApi<T, K = T>(
   url: string,
   options?: {
      searchParams?: Record<string, string>;
      onSuccess?: (data: K) => void;
      transformData?: (data: T) => K;
      persistState?: boolean;
   }
) {
   const {state, loading, error, setState, setLoading, setError} = useAsyncState<K>();
   const handleError = useHandleApiError({url, setError, setLoading});

   const request = React.useCallback(
      (urlEnding: string = '') => {
         let _url = url + urlEnding;
         const searchParams = options?.searchParams;

         if (searchParams) {
            _url = `${_url}?${new URLSearchParams(searchParams)}`;
         }

         setLoading(true);
         !options?.persistState && setState(undefined);
         ApiService.getSecureJson(_url)
            .then((res) => {
               return res.json();
            })
            .then((_data: T) => {
               const data = options?.transformData ? options.transformData(_data) : _data;
               setState(data as K);
               options?.onSuccess?.(data as K);
               setLoading(false);
            })
            .catch(handleError());
      },
      [
         handleError,
         options?.onSuccess,
         options?.transformData,
         options?.persistState,
         options?.searchParams,
         setLoading,
         setState,
         url,
      ]
   );
   return {request, state, loading, error};
}
